import React from "react";
import { book } from "../data/book";
type BookCoverProps = {
  className?: string;
};
export function BookCover({
  className = ""
}: BookCoverProps) {
  return <div className={`relative [perspective:1600px] ${className}`} data-id="element-32" data-mp="323d5ib2f4dwa">
      <div className="relative aspect-[5/8] w-full [transform:rotateY(-14deg)_rotateX(3deg)] [transform-style:preserve-3d]" data-id="element-33" data-mp="2x51qllx9nd77">
        {/* Page block */}
        <div aria-hidden="true" className="absolute inset-y-[1.5%] right-[-5%] w-[7%] rounded-r-sm bg-[repeating-linear-gradient(90deg,#f3f0f6_0px,#f3f0f6_2px,#d9d2e2_3px)] shadow-[inset_4px_0_6px_rgba(0,0,0,0.35)]" data-id="element-34" data-mp="2o5epz2cd2bf7" />
        {/* Front cover */}
        <div className="absolute inset-0 overflow-hidden rounded-r-md rounded-l-sm bg-plum shadow-[30px_40px_60px_-15px_rgba(0,0,0,0.8)] ring-1 ring-white/10" data-id="element-35" data-mp="2egmzkymy7z6e">
          <img src={book.cover} alt={`${book.title}: ${book.subtitle}, by ${book.author}`} className="absolute inset-0 h-full w-full object-cover" data-id="element-36" data-mp="24i7af17hezzj" />
          {/* Spine shading */}
          <div aria-hidden="true" className="absolute inset-y-0 left-0 w-[4%] bg-black/30" data-id="element-37" data-mp="19ardt7z8jnt4" />
          <div aria-hidden="true" className="absolute inset-y-0 left-[4%] w-px bg-white/15" data-id="element-38" data-mp="198y57n52atih" />
        </div>
      </div>
    </div>;
}